<template>
	<!-- 修改用户信息弹框 -->
	<!-- 目前只支持卡号、用户名、手机号 -->
	<div>
		<el-dialog title="修改用户信息" :visible.sync="userEditVisible" width="50%" :close-on-click-modal="false">
			<el-form :model="user" :rules="userEditRules" ref="userEditForm" label-width="100px">
				<el-form-item prop="role_change" label="岗位">
					<el-select v-model="user.role_change" multiple placeholder="请选择岗位" @change="selectChange" clearable>
						<el-option v-for="item in roleList" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</el-form-item>

				<el-form-item prop="shift" label="班次">
					<el-select v-model="user.shift" placeholder="请选择班次" @change="selectChangeShift" clearable>
						<el-option v-for="item in shiftList" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item prop="cardNumber" label="卡号">
					<el-input v-model="user.cardNumber" placeholder="请输入卡号" />
				</el-form-item>
				<el-form-item prop="name" label="用户名">
					<el-input v-model="user.name" placeholder="请输入用户名" />
				</el-form-item>
				<el-form-item prop="phone" label="手机号">
					<el-input v-model="user.phone" placeholder="请输入手机号" />
				</el-form-item>
				<el-form-item prop="roleId_change" label="角色">
					<el-select v-model="user.roleId_change" placeholder="请选择角色" @change="selectChange_roleId" clearable>
						<el-option v-for="item in roleId_list" :key="item.id" :label="item.roleName" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item prop="enableLogon" label="允许登录">
					<el-checkbox v-model="user.enableLogon"></el-checkbox>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button type="primary" @click="onSubmit">修改</el-button>
				<el-button @click="userEditVisible = false">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as api from "@/api/factory/user/list";
	export default {
		data() {
			return {
				userEditVisible: false,
				user: {
					name: "",
					phone: "",
					cardNumber: "",
					//----sta
					role: 0, //hongmj: 疑似岗位的叠加?
					role_change: null, //岗位（显示用 )
					//----end
					shift: "", //班次
					//--------------
					roleId: null, //角色
					roleId_change: null, //角色(显示用)
					//--------------
					enableLogon: null,
				},
				roleList: [], //岗位列表
				shiftList: [], //班次列表
				roleId_list: [], //角色列表

				userEditRules: {
					//   验证用户名是否合法
					name: [{
							required: true,
							message: "请输入用户名",
							trigger: "blur"
						},
						{
							min: 1,
							max: 15,
							message: "长度在1 到 15 个字符之间",
							trigger: "blur",
						},
					],

					// phone: [
					//   { required: true, message: '请输入手机号', trigger: 'blur' },
					//   { validator: this.$valid.checkPhone, trigger: 'blur' }
					// ],
					role_change: [{
						required: true,
						message: "请选择岗位",
						trigger: "blur"
					}, ],
					shift: [{
						required: true,
						message: "请选择班次",
						trigger: "blur"
					}, ],
					roleId_change: [{
						required: true,
						message: "请选择角色",
						trigger: "blur"
					}],
				},
			};
		},

		methods: {
			// 外部调用，展示修改用户信息的弹框
			show(workerInfo) {
				console.log("workerInfo=", workerInfo);

				this.user.workerId = workerInfo.workerId;
				this.user.cardNumber = workerInfo.cardNumber;
				this.user.name = workerInfo.name;
				this.user.phone = workerInfo.phone;
				//----sta
				this.user.role = workerInfo.role; //岗位
				// this.user.role_change = workerInfo.role_change; //岗位(显示用)
				//----end
				this.user.shift = workerInfo.shift; //班次
				//----sta
				this.user.roleId = workerInfo.roleId; //角色
				this.user.roleId_change = workerInfo.roleId_change; //角色(显示用)
				//----end
				this.user.enableLogon = workerInfo.enableLogon;
				this.userEditVisible = true;
			},

			// 初始化岗位选择框
			initRoleList() {
				const roleList = [];
				const roleObj = this.$enum.roleObj;
				for (var key in roleObj) {
					const obj = roleObj[key];
					roleList.push({
						value: obj.value,
						label: obj.name
					});
				}
				this.roleList = roleList;
			},
			// 岗位选择框，内容改变事件
			selectChange(val) {
				//hongmj: 传进来是每个值，1,2,4,8,16,32
				// 盘头=1,档车=2,穿纱=4,机修=8,管理员=16,整机=32.
				console.log("val=", val);
				//role(岗位)必须是 所有值汇总
				this.user.role = 0; //为安全初始化
				for (let i = 0; i < val.length; i++) {
					this.user.role += val[i];
				}

			},

			//----------
			// 初始化角色选择框
			initRoleIdList() {
				api.getRole().then((res) => {
					// console.log(res);
					this.roleId_list = res.data;
					// console.log(this.roleId_list);
				});
			},
			// 角色选择框，内容改变事件
			selectChange_roleId(val) {
				// console.log("val=", val);  //hongmj:这是roleId = 角色id
				this.user.roleId = val;
			},

			//----------STA
			// 初始化班次选择框
			initShiftList() {
				const shiftList = [];
				const shiftObj_value = this.$enum.shiftObj_value;
				for (var key in shiftObj_value) {
					const obj = shiftObj_value[key];
					shiftList.push({
						value: obj.value,
						label: obj.name
					});
				}
				this.shiftList = shiftList;
			},
			// 班次选择框，内容改变事件
			selectChange_shift(val) {},
			//----------END
			// 点击修改按钮
			onSubmit() {
				this.$refs.userEditForm.validate((valid) => {
					if (!valid) return;
					const clone = this._.cloneDeep(this.user);
					clone.phone = this.utils.isEmpty(clone.phone) ? null : clone.phone;
					clone.cardNumber = this.utils.isEmpty(clone.cardNumber) ?
						null :
						clone.cardNumber;
					api.editUser(clone).then((res) => {
						this.$emit("update");
						this.userEditVisible = false;
						this.$Message.success("修改信息成功！");
					});
				});
			},
		},
		mounted() {
			this.initRoleList(); //初始化岗位选择框
			this.initRoleIdList(); //初始化角色选择框

			this.initShiftList(); //初始化班次选择框
		},
	};
</script>

<style scoped lang="sass"></style>